import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

import { type DropdownListItem, DropDownListItemStatus } from '../../Dropdown/types';

export const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'withIcon',
})<{ status?: DropdownListItem['status']; withIcon?: boolean }>(({ status, withIcon, theme }) => {
  let errorStyles = {};
  if (status === DropDownListItemStatus.ERROR) {
    errorStyles = {
      border: `1px solid ${theme.palette.error.main}`,
      backgroundColor: `${theme.palette.common.white} !important`,
      color: theme.palette.error.main,
      '& .MuiChip-deleteIcon': {
        color: theme.palette.error.main,
      },
    };
  }

  let warningStyles = {};
  if (status === DropDownListItemStatus.WARNING) {
    warningStyles = {
      border: `1px solid ${theme.palette.warning.main}`,
      backgroundColor: `${theme.palette.common.white} !important`,
      color: theme.palette.warning.main,
      '& .MuiChip-deleteIcon': {
        color: theme.palette.warning.main,
      },
    };
  }

  return {
    height: 'auto !important',
    padding: '3px 0 !important',
    ...errorStyles,
    ...warningStyles,

    '& .MuiChip-label': {
      paddingLeft: withIcon ? '4px !important' : undefined,
    },

    '& .MuiChip-deleteIcon': {
      marginRight: '4px !important',
    },
  };
});
